module.exports = __webpack_public_path__ + "static/media/Stars.32a0431c.mp4";